import leftQuote from "../media/stay-calm.png";
import rightQuote from "../media/quack.png";

function Footer() {
    return (
        <footer className="footer">

            <div className="container">

                <div className="row align-items-center">

                    {/* Left */}

                    <div className="col-lg-3 col-12 text-center text-lg-start">

                        <img
                            src={leftQuote}
                            alt=""
                            className="footer-side"
                        />

                    </div>

                    {/* Center */}

                    <div className="col-lg-6 col-12">

                        <div className="footer-center">

                            <h2>
                                NO ROADMAP. NO UTILITY.
                                <br />
                                <span>ONLY TUBE.</span>
                            </h2>

                            <div className="footer-divider"></div>

                            <p>
                                © 2026 TUBE DUCK. ALL RIGHTS RESERVED.
                            </p>

                        </div>

                    </div>

                    {/* Right */}

                    <div className="col-lg-3 col-12 text-center text-lg-end">

                        <img
                            src={rightQuote}
                            alt=""
                            className="footer-side"
                        />

                    </div>

                </div>

            </div>

        </footer>
    );
}

export default Footer;